import { ENOPOrganType, EResourceType } from '#shared';

import { useQueryHubsResourceReport, useQuerySurgeonsRegions } from '../../api';

import type { HumanResource } from '#entities';

export const useSurgeonsByRawRegion = (
  regionName: string,
): Partial<Record<ENOPOrganType, HumanResource[]>> => {
  const { data: regions = [] } = useQuerySurgeonsRegions();

  const grouped: Partial<Record<ENOPOrganType, HumanResource[]>> = {
    [ENOPOrganType.Heart]: [],
    [ENOPOrganType.Liver]: [],
    [ENOPOrganType.Lungs]: [],
  };
  const { data: hubs } = useQueryHubsResourceReport();

  const targetRegion = regions.find(r => r.name === regionName);

  if (!targetRegion || !hubs.length) {
    return grouped;
  }

  const regionHubIds = new Set(targetRegion.hubs?.map(h => h.id));

  for (const hub of hubs) {
    const hubLocationId = hub.location?.id;

    if (!hubLocationId || !regionHubIds.has(hubLocationId)) {
      continue;
    }

    const surgeonEntry = hub.staffInfo.find(
      s => s.teamMemberType === EResourceType.Surgeon,
    );

    if (!surgeonEntry) {
      continue;
    }

    for (const detail of surgeonEntry.details) {
      const organ = detail.organType;
      const surgeons = detail.resources as HumanResource[];

      grouped[organ] ??= [];
      grouped[organ].push(...surgeons);
    }
  }

  return grouped;
};
